import { render, staticRenderFns } from "./LedgerTable.vue?vue&type=template&id=2d54e574&scoped=true&"
import script from "./LedgerTable.vue?vue&type=script&lang=js&"
export * from "./LedgerTable.vue?vue&type=script&lang=js&"
import style0 from "./LedgerTable.vue?vue&type=style&index=0&id=2d54e574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d54e574",
  null
  
)

export default component.exports